<script lang="ts">
    import { translatePath } from "./taskMapping"
    import Modal from "../../components/Modal.svelte"
    import Cta from "../../components/CTA.svelte"
    export let item
    let showTaskChanges: { actions: any } | null

    const getPrevious = (previous: string, current = "previous") => {
        if (previous == "null") return current == "current" ? "Kein aktueller Eintrag" : "Kein früherer Eintrag"
        if (previous == "true") return "Ja"
        if (previous == "false") return "Nein"
        if (previous == "0") return "Nein"
        if (previous == "100") return "Ja"
        if (typeof previous == "string") return previous.replaceAll(/<[^>]*>/g, "")
        return previous
    }
    function isNumeric(str: string | number) {
        if (typeof str != "string") return false
        return !isNaN(str) && !isNaN(parseFloat(str))
    }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<Cta
    on:click="{() => {
        showTaskChanges = item
    }}"
    content="Details Anzeigen"
    icon="solar_info-circle-outline"
    type="tableButtonWithContent"
/>
{#if showTaskChanges}
    <Modal
        show="{true}"
        on:close="{() => (showTaskChanges = null)}"
        showCloseIcon="{true}"
    >
        <h4 slot="header">Einsatzveränderungen</h4>
        <div class="task-changes">
            <div class="grid-container">
                <div class="row headline">
                    <div class="grid-item header mobile-hide">Feldname</div>
                    <div class="grid-item header">Vorheriger Wert</div>
                    <div class="grid-item header">Aktueller Wert</div>
                </div>
                {#each showTaskChanges?.actions || [] as log, i (i)}
                    <div class="row items">
                        <div class="grid-item">
                            <div class="header">Feldname</div>
                            <div>{@html translatePath(log.field)}</div>
                        </div>
                        <div class="grid-item">
                            <div class="header">Vorheriger Wert</div>
                            <div>
                                {isNumeric(getPrevious(log.previous))
                                    ? Number(getPrevious(log.previous)).toFixed(2)
                                    : getPrevious(log.previous)}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="header">Aktueller Wert</div>
                            <div>
                                {isNumeric(getPrevious(log.current, "current"))
                                    ? Number(getPrevious(log.current, "current")).toFixed(2)
                                    : getPrevious(log.current, "current")}
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </Modal>
{/if}

<style lang="less">
    h4 {
        color: white;
    }
    .task-changes {
        padding: 10px;

        .grid-container {
            display: grid;
            grid-template-columns: 1fr;
            align-items: start;
            width: 100%;
            margin: 0 auto;

            .row {
                display: flex;
                gap: 10px;

                &:nth-child(even) {
                    background-color: var(--grey-300);
                }
                &:nth-child(odd) {
                    background-color: transparent;
                }
                &.headline {
                    background-color: var(--text-000);
                }
            }
            @media (max-width: 500px) {
                gap: 10px;
                grid-template-columns: 1fr;
                .row {
                    flex-direction: column;
                }
            }

            .grid-item {
                flex: 1;
                padding: 8px;
                text-align: left;
                overflow: hidden;
                text-wrap: wrap;
                display: flex;
                flex-direction: column;
                div {
                    padding: 3px;
                }
                @media (min-width: 501px) {
                    .header {
                        display: none;
                    }
                }
            }

            .header {
                font-weight: bold;
                background-color: var(--text-000);
                color: white;

                @media (max-width: 500px) {
                    &:not(:first-child) {
                        display: none;
                    }
                    &.mobile-hide {
                        display: none;
                    }
                }
            }
            .items {
                .header {
                    color: black;
                    background-color: transparent;
                    text-decoration: underline;
                }
            }
        }
    }
</style>
